<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">

          <el-row :span="2" style="margin-top: 30px;">
              名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              播放地址:<el-input v-model="wangzhi" style="width: 150px;" placeholder="请输入播放地址"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              <el-upload
                class="avatar-uploader"
                action="http://data3.yoooooo.com/index.php/index/data/pythonImgSave"
                :show-file-list="false"
                :on-success="handleAvatarSuccess1"
                style="display: inline;">

                <img style="width: 60px;height: 60px;" v-if="addImg" :src="addImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>

          </el-row>

          <el-row :span="2" style="margin-top: 30px;">
              <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
          </el-row>
      </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="300"
              label="名称"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(scope.row.name,scope.row.id,1)">{{scope.row.name}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="播放地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(scope.row.url,scope.row.id,2)">{{scope.row.url}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="250"
              label="图片查看\修改"
               >
              <template slot-scope="scope">

                <el-row v-if="scope.row.img_s == 0">

                  <el-col :span="20" style="text-align: center;margin-top: 20px;" @click.native="seeImg(scope.$index,scope.row)">
                    查看图片

                  </el-col>





                </el-row>
                <el-row v-if="scope.row.img_s == 1">

                  <el-upload
                    class="avatar-uploader"
                    action="http://data3.yoooooo.com/index.php/index/data/pythonImgSave"

                    :show-file-list="false"
                    @click.native="ceshi(scope.$index,scope.row.id)"
                    :on-success="handleAvatarSuccess"
                    style="display: inline;">

                    <img style="width: 60px;height: 60px;" v-if="scope.row.img" :src="scope.row.img" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>





                </el-row>
              </template>
            </el-table-column>

            <el-table-column

              width="200"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id,scope.$index)">删除</el-col>

                 </el-row>
               </template>
            </el-table-column>
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="names"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         name:'',
         wangzhi:'',
         names:'',
         disDialogVisible:false,
         changeId:0,
         t:0,
         addImg:'',
         addImgs:'',
         imageId:0,
         seachName:'',
         imgId:0,


      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
    seach(){
      this.loadList();
    },
    ceshi(index,id){
      this.imageId = index
      this.imgId = id
    },
    seeImg(index,row){
      row['img_s'] = 1

      this.$set(this.list,index,row);



    },
    UploadUrl(id){

      return "http://data3.yoooooo.com/index.php/index/data/pythonImgSave"
    },
    handleAvatarSuccess(res, file) {
       
      this.imgChange(this.imgId,file.response.data)

    },
    handleAvatarSuccess1(res, file){

       
      this.addImg = URL.createObjectURL(file.raw);
      this.addImgs = file.response.data

    },
    imgChange(id,img){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          img:img

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zhiboImgChange'
      })
      .then(res=>{


        this.list[this.imageId]['img'] = res.data.data




      })
      .catch(err=>{

      });
    },
    dischange(name,id,t){
      this.t = t;
      this.changeId = id
      this.names = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.changeId,
          name:this.names,
          t:this.t
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zhiboChanges'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.msg('名称重复','error');
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zhibolist'
      })
      .then(res=>{

        this.list = res.data.list;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
        })
        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },




    del(id,index){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/zhiboDel'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.name == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.wangzhi == ''){
        this.msg('请填写网址','error')
        return false
      }


      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/zhiboAdd',
      	params:{
      		name:this.name,
          img:this.addImgs,
      		url:this.wangzhi,

      	}
      })
      .then(res=>{

        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/fxzhibo.vue